import { Color, Icon, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { QuickStartAction } from '../../types/quickStartAction'
import { QuickStartAccordionContent } from './elements/QuickStartAccordionContent'
import * as Styled from './styles'

interface QuickStartAccordionProps {
  description?: string
  id: string
  isCompleted: boolean
  isOpen: boolean
  onToggle: (id: string) => void
  primaryAction?: QuickStartAction
  secondaryAction?: QuickStartAction
  title: string
}

export const QuickStartAccordion = ({
  description,
  id,
  isCompleted,
  isOpen,
  onToggle,
  primaryAction,
  secondaryAction,
  title,
}: QuickStartAccordionProps): ReactElement => {
  const handleTriggerClick = useCallback(() => {
    if (isCompleted) {
      return
    }

    onToggle(id)
  }, [id, isCompleted, onToggle])

  return (
    <Styled.QuickStartAccordionWrapper isOpen={isOpen}>
      <Styled.QuickStartAccordionTrigger
        disabled={isCompleted}
        isCompleted={isCompleted}
        onClick={handleTriggerClick}
        type="button"
      >
        <Icon icon={isCompleted ? 'circleCheck' : 'circleDashed'} />
        <Text
          variant="bodyMD"
          weight={!isCompleted && isOpen ? 'semiBold' : 'medium'}
          {...(isCompleted ? { colorVariant: 'disable', strikethrough: true } : { color: Color.Black })}
        >
          {title}
        </Text>
      </Styled.QuickStartAccordionTrigger>
      <Styled.QuickStartAccordionContentWrapper isOpen={isOpen}>
        <Styled.QuickStartAccordionContentInner>
          <QuickStartAccordionContent
            description={description}
            primaryAction={primaryAction}
            secondaryAction={secondaryAction}
          />
        </Styled.QuickStartAccordionContentInner>
      </Styled.QuickStartAccordionContentWrapper>
    </Styled.QuickStartAccordionWrapper>
  )
}
